import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';

import {
  Form,
  FormHeader,
  FormErrors,
  FormFooter,
  FormSubmit,
  TextfieldElement,
  SelectElement,
  withRouter
} from "cw-styleguide-react";

class SearchFilterForm extends Component {

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {
    return (

          <Form theme={['no-padding', 'no-background', 'on-colour', 'inline-groups']}>
            <FormHeader title={this.props.t('view.search.title')} isPageTitle={true}
                        introduction={this.props.t('view.search.introduction')}>
              <p><strong>{this.props.t('view.search.prompt')}</strong></p>
            </FormHeader>

            <FormErrors errors={this.props.formErrors}/>

            {/* Keyword */}
            <TextfieldElement size={'medium'} id={'keyword'} name={'keyword'}
                              label={this.props.t('view.results.filters.keyword.label')}
                              placeholder={this.props.t('view.results.filters.keyword.placeholder')}
                              value={this.props.filterValues.keyword}
                              onChange={this.props.handleChange}
                              errors={this.props.formErrors['keyword']}
            />

            {/* Location */}
            <TextfieldElement size={'medium'} id={'location'} name={'location'}
                              label={this.props.t('view.results.filters.location.label')}
                              value={this.props.filterValues.location}
                              onChange={this.props.handleChange}
                              errors={this.props.formErrors['location']}
            />

            {/* proximity */}
            <SelectElement size={'medium'} label={this.props.t('local:view.results.filters.proximity.label.long')}
                           id={'proximity'}
                           name={'proximity'}
                           value={this.props.filterValues.proximity}
                           onChange={this.props.handleChange}
                           grouped={true}
                           options={this.props.filters.proximity}
            />


            {/* proximity */}
            <SelectElement size={'medium'} label={this.props.t('local:view.results.filters.qualificationType.label')}
                           id={'qualificationType'}
                           name={'qualificationType'}
                           value={this.props.filterValues.qualificationType}
                           onChange={this.props.handleChange}
                           grouped={true}
                           options={[{
                             value: '',
                             label: this.props.t('styleguide:forms.all')
                           }].concat(this.props.filters.qualificationType)}
            />

            {/* studyMethodType */}
            <SelectElement size={'medium'} label={this.props.t('local:view.results.filters.studyMethodType.label')}
                           id={'studyMethodType'}
                           name={'studyMethodType'}
                           value={this.props.filterValues.studyMethodType}
                           onChange={this.props.handleChange}
                           grouped={true}
                           options={[{
                             value: '',
                             label: this.props.t('styleguide:forms.all')
                           }].concat(this.props.filters.studyMethodType)}
            />

            {/*/!* studyMethodHours *!/*/}
            {/*<SelectElement size={'medium'} label={this.props.t('local:view.results.filters.studyMethodHours.label')}*/}
            {/*               id={'studyMethodHours'}*/}
            {/*               name={'studyMethodHours'}*/}
            {/*               value={this.props.filterValues.studyMethodHours}*/}
            {/*               onChange={this.props.handleChange}*/}
            {/*               grouped={true}*/}
            {/*               options={[{*/}
            {/*                 value: '',*/}
            {/*                 label: this.props.t('styleguide:forms.all')*/}
            {/*               }].concat(this.props.filters.studyMethodHours)}*/}
            {/*/>*/}

            {/*/!* studyMethodTimes *!/*/}
            {/*<SelectElement size={'medium'} label={this.props.t('local:view.results.filters.studyMethodTimes.label')}*/}
            {/*               id={'studyMethodTimes'}*/}
            {/*               name={'studyMethodTimes'}*/}
            {/*               value={this.props.filterValues.studyMethodTimes}*/}
            {/*               onChange={this.props.handleChange}*/}
            {/*               grouped={true}*/}
            {/*               options={[{*/}
            {/*                 value: '',*/}
            {/*                 label: this.props.t('styleguide:forms.all')*/}
            {/*               }].concat(this.props.filters.studyMethodTimes)}*/}
            {/*/>*/}

            {/* programme */}
            <SelectElement size={'medium'} label={this.props.t('local:view.results.filters.programme.label')}
                           id={'programme'}
                           name={'programme'}
                           value={this.props.filterValues.programme}
                           onChange={this.props.handleChange}
                           grouped={true}
                           options={[{
                             value: '',
                             label: this.props.t('styleguide:forms.all')
                           }].concat(this.props.filters.programme)}
            />

            {/* courseType */}
            <SelectElement size={'medium'} label={this.props.t('local:view.results.filters.courseType.label')}
                           id={'courseType'}
                           name={'courseType'}
                           value={this.props.filterValues.courseType}
                           onChange={this.props.handleChange}
                           grouped={true}
                           options={[{
                             value: '',
                             label: this.props.t('styleguide:forms.all')
                           }].concat(this.props.filters.courseType)}
            />




            <FormFooter>
              <FormSubmit title={'Search'} icon={{type: 'chevron-right', position: 'right'}} value={'Search'}
                          onClick={this.props.handleSubmit}>
                {this.props.t('styleguide:forms.search')}
              </FormSubmit>
            </FormFooter>
          </Form>

    );
  }
}

export default withRouter(withTranslation('local')(SearchFilterForm));
